import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initPostHog } from "@/lib/posthog";

initPostHog();

// Clerk-js can fail to load when its DNS isn't live yet (e.g. fresh production
// instance). Swallow ONLY those rejections so the Team-access login stays usable.
window.addEventListener("unhandledrejection", (e) => {
  const reason = e?.reason || {};
  const text = `${reason.name || ""} ${reason.message || ""} ${reason.code || ""}`;
  if (/clerk/i.test(text)) {
    console.warn("Clerk failed to load — falling back to Team access login:", reason.message || reason);
    e.preventDefault();
  }
});
window.addEventListener("error", (e) => {
  const text = `${e?.error?.name || ""} ${e?.message || ""}`;
  if (/clerk/i.test(text)) {
    console.warn("Clerk failed to load — falling back to Team access login");
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
